import React from "react";
import { FiHome, FiUsers, FiUserCheck, FiUserX } from "react-icons/fi";
import tw from "tailwind-styled-components";

function SummaryCards({ data }) {

    const summaryData = {
        totalProperties: data?.length || 0,
        totalTenants: data?.reduce((sum, item) => sum + (item.totalTenants || 0), 0) || 0,
        presentToday: data?.reduce((sum, item) => sum + (item.present || 0), 0) || 0,
        absentToday: data?.reduce((sum, item) => sum + (item.absent || 0), 0) || 0,
    };

    const summary = [
        {
            amount: summaryData.totalProperties,
            label: "Total Properties",
            color: "text-black",
            icon: <FiHome size={20} className="text-blue-400" />,
        },
        {
            amount: summaryData.totalTenants,
            label: "Total Tenants",
            color: "text-black",
            icon: <FiUsers size={20} className="text-green-400" />,
        },
        {
            amount: summaryData.presentToday,
            label: "Present Today",
            color: "text-black",
            icon: <FiUserCheck size={20} className="text-purple-400" />,
        },
        {
            amount: summaryData.absentToday,
            label: "Absent Today",
            color: "text-black",
            icon: <FiUserX size={20} className="text-red-400" />,
        },
    ];

    return (
        <Wrapper>
            <ScrollCard>
                {summary.map((item, index) => (
                    <Card key={index}>
                        <div className="h-16">
                            <Value color={item.color}>{item.amount}</Value>
                            <Label>
                                {item.label}
                            </Label>
                        </div>

                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}


const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;
const Card = tw.div`
  min-w-[200px] p-3 rounded-md bg-white shadow-md 
  cursor-pointer hover:shadow-sm hover:shadow-primary-color

`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  
  ${({ color }) => color}
`;

export default SummaryCards;